<template>
  <b-card>
    <h3 class="mb-1">Paquete Preventivo</h3>
    <p class="text-muted">ID: {{ $route.params.id }}</p>
    <p>Este es un placeholder. Aquí puedes renderizar estudios incluidos, diagnósticos, precios, coberturas, adjuntos, etc.</p>
  </b-card>
</template>
<script>
export default { name: 'VerPaquetePrev' }
</script>